/* =============================================================
   BBQ KINGS — Theme JavaScript
   Handles: header scroll, mobile menu, countdown, menu tabs
   ============================================================= */

document.addEventListener('DOMContentLoaded', function () {
  // ── HEADER SCROLL ──
  const header = document.querySelector('.site-header');
  if (header) {
    const isHome = window.location.pathname === '/';
    if (!isHome) {
      header.classList.add('is-inner');
    }
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }, { passive: true });
  }

  // ── HERO VIDEO AUTOPLAY ──
  // Force autoplay on all hero videos (fixes iOS Safari / some mobile browsers)
  var heroVideos = document.querySelectorAll('.hero video');
  heroVideos.forEach(function (video) {
    video.muted = true; // Ensure muted (required for autoplay)
    video.setAttribute('playsinline', ''); // iOS requirement
    video.setAttribute('webkit-playsinline', ''); // Older iOS
    var playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(function () {
        // Autoplay was prevented — try again on first user interaction
        function playOnInteraction() {
          video.play();
          document.removeEventListener('touchstart', playOnInteraction);
          document.removeEventListener('click', playOnInteraction);
        }
        document.addEventListener('touchstart', playOnInteraction, { once: true });
        document.addEventListener('click', playOnInteraction, { once: true });
      });
    }
  });

  // ── MOBILE MENU ──
  const toggle = document.querySelector('.mobile-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  if (toggle && mobileMenu) {
    toggle.addEventListener('click', function () {
      mobileMenu.classList.toggle('is-open');
      const isOpen = mobileMenu.classList.contains('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
      toggle.innerHTML = isOpen
        ? '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
        : '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></svg>';
    });
  }

  // ── COUNTDOWN ──
  const countdownEl = document.querySelector('[data-countdown]');
  if (countdownEl) {
    const target = new Date(countdownEl.dataset.countdown).getTime();
    function updateCountdown() {
      const now = Date.now();
      const diff = target - now;
      if (diff <= 0) {
        countdownEl.innerHTML = '<div style="font-family:var(--font-display);font-weight:900;font-size:2rem;color:var(--color-orange);">🔥 WE\'RE OPEN!</div>';
        return;
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      countdownEl.innerHTML = `
        <div class="countdown__unit"><div class="countdown__number">${days}</div><div class="countdown__label">Days</div></div>
        <div class="countdown__sep">:</div>
        <div class="countdown__unit"><div class="countdown__number">${String(hours).padStart(2,'0')}</div><div class="countdown__label">Hours</div></div>
        <div class="countdown__sep">:</div>
        <div class="countdown__unit"><div class="countdown__number">${String(minutes).padStart(2,'0')}</div><div class="countdown__label">Min</div></div>
        <div class="countdown__sep">:</div>
        <div class="countdown__unit"><div class="countdown__number">${String(seconds).padStart(2,'0')}</div><div class="countdown__label">Sec</div></div>
      `;
      requestAnimationFrame(function () {
        setTimeout(updateCountdown, 1000);
      });
    }
    updateCountdown();
  }

  // ── MENU TABS ──
  const tabs = document.querySelectorAll('.menu-tab');
  const panels = document.querySelectorAll('.menu-panel');
  if (tabs.length && panels.length) {
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const target = tab.dataset.target;
        tabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        panels.forEach(function (p) {
          p.style.display = p.dataset.panel === target ? 'block' : 'none';
        });
      });
    });
  }
});
